// extracted by mini-css-extract-plugin
module.exports = {"option":"_99551c8aa8--option--CxgFp","icon":"_99551c8aa8--icon--Xsj96"};